
import { useState } from 'react';
import { PlaceResult } from './types';
import { STATE_ABBREVIATIONS } from '@/utils/stateNameToAcronym';

export const usePlaceDetails = () => {
  const [place, setPlace] = useState<google.maps.places.PlaceResult | null>(null);

  // Handle place changed event
  const handlePlaceChanged = (newPlace: google.maps.places.PlaceResult) => {
    setPlace(newPlace);
    
    // Clean up autocomplete UI after selection
    setTimeout(() => {
      const pacContainers = document.querySelectorAll('.pac-container');
      pacContainers.forEach(container => {
        if (container instanceof HTMLElement) {
          container.style.display = 'none';
          container.style.visibility = 'hidden';
          container.style.pointerEvents = 'none'; // Make sure it's not clickable
          
          // Remove from DOM entirely if it's persisting
          if (container.parentNode) {
            try {
              document.body.removeChild(container);
            } catch (e) {
              // Ignore if already removed
            }
          }
        }
      });
      
      // Hide any remaining "Powered by Google" elements
      const poweredByGoogle = document.querySelectorAll('.pac-logo:after');
      poweredByGoogle.forEach(element => {
        if (element instanceof HTMLElement) {
          element.style.display = 'none';
          element.style.visibility = 'hidden';
        }
      });
    }, 100);
  };

  // Extract place details
  const getPlaceDetails = (): PlaceResult | null => {
    if (!place || !place.address_components) return null;

    let street = '';
    let city = '';
    let state = '';
    let zip = '';

    for (const component of place.address_components) {
      const types = component.types;
      
      if (types.includes('street_number')) {
        street = component.long_name + ' ';
      } else if (types.includes('route')) {
        street += component.long_name;
      } else if (types.includes('locality')) {
        city = component.long_name;
      } else if (types.includes('administrative_area_level_1')) {
        // For state, we want the long_name (e.g., California instead of CA)
        // This gives us the full state name to match the dropdown options
        state = component.long_name;
        console.log("Found state from place API:", state);
      } else if (types.includes('postal_code')) {
        zip = component.long_name;
      }
    }

    const coordinates = place.geometry?.location ? {
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng()
    } : undefined;

    const result = {
      address: street || place.formatted_address || '',
      city,
      state,
      zip,
      coordinates
    };

    console.log("Extracted place details:", result);
    return result;
  };

  return {
    place,
    handlePlaceChanged,
    getPlaceDetails
  };
};
